import { ACTIVE_PROFILE } from '../../config';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import loggerMiddleware from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import authReducer from './auth/reducer';
import errorsReducer from './errors/reducer';
import impersonateReducer from './impersonate/reducer';
import entitiesReducer from './entities/reducer';
import kpisReducer from './kpis/reducer';
import passwordResetReducer from './passwordReset/reducer';
import notificationsReducer from './notifications/reducer';
import introReducer from './intro/reducer';
import sessionReducer from './session/reducer';
import versionReducer from './version/reducer';
import accountingReducer from './accounting/reducer';
import audienceReducer from './audience/reducer';

const reducer = combineReducers({
    auth:authReducer,
    impersonate:impersonateReducer,
    errors:errorsReducer,
    kpis:kpisReducer,
    entities:entitiesReducer,
    passwordReset:passwordResetReducer,
    notifications:notificationsReducer,
    intro:introReducer,
    session:sessionReducer,
    version:versionReducer,
    accounting:accountingReducer,
    audience:audienceReducer
  });
const middleware = applyMiddleware(
    thunkMiddleware,
    loggerMiddleware,
  );

const composeEnhancers = ((ACTIVE_PROFILE !== 'prod' || ACTIVE_PROFILE !== 'production') && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;


export default createStore(reducer, composeEnhancers(middleware));



// WEBPACK FOOTER //
// ./src/shared/redux/index.js